import { render, staticRenderFns } from "./perheader.vue?vue&type=template&id=277872a3&scoped=true&"
import script from "./perheader.vue?vue&type=script&lang=js&"
export * from "./perheader.vue?vue&type=script&lang=js&"
import style0 from "./perheader.vue?vue&type=style&index=0&id=277872a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277872a3",
  null
  
)

export default component.exports